<template>
  <div>
    <span class="text-uppercase field-label">{{deliverableContactsLabel(deliverable.deliverable_template_id)}}</span>
    <div class="info-bubbles exclude-outside-click" @click="showAddContact">
      <span
        class="initials badge badge-primary exclude-outside-click"
        v-b-tooltip.hover.html
        v-for="(fieldValue, index) in deliverable.contacts"
        :key="'fieldValue'+index"
        :title="(index < 3) ? fieldValue.name : getTitle(deliverable.contacts)"
        v-if="index<=3"
      >
        <span class="exclude-outside-click" v-if="index<3">{{fieldValue.name | textInitials}}</span>
        <span class="exclude-outside-click" v-if="index==3">+{{ deliverable.contacts.length-index }}</span>
      </span>
      <span class="badge badge-gray exclude-outside-click" v-if="!deliverable.contacts.length">No {{deliverableContactsLabel(deliverable.deliverable_template_id)}}</span>
      <plus-button v-show="!addContactFlag" class="tagged-contacts plus-button plus-button--small"></plus-button>
    </div>
    <multiselect
      ref="deliverableListContacts"
      v-click-outside="outside"
      v-show="addContactFlag"
      v-model="deliverable.contacts"
      :option-height="120"
      :close-on-select="false"
      :options="contacts"
      :id="deliverable.id"
      :taggable="true"
      :multiple="true"
      :show-labels="false"
      :searchable="true"
      :internal-search="false"
      :customLabel="contactCustomLabel"
      :open-direction="isMobile() ? 'bottom' : ''"
      label="name"
      track-by="id"
      tag-placeholder="Add a new contact"
      @search-change="onContactSearch"
      @tag="createContact"
      @close="addContactFlag=false"
      @open="onContactSearch(false)"
      @input="addDeliverableContact({contactData: deliverable.contacts, deliverableId: deliverable.id})"
    >
      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <div v-if="props.option.isTag">Add new contact <strong>{{props.option.label}}</strong></div>
          <div class="option__name" v-if="props.option.name" >{{ props.option.name }}&nbsp;</div>
          <div class="option__company" v-if="props.option.company_name" >{{ props.option.company_name }}&nbsp;</div>
          <div class="option__phone" v-if="props.option.cell_phone" >{{ props.option.cell_phone }}&nbsp;</div>
          <div class="option__email" v-if="props.option.email_address" >{{ props.option.email_address }}&nbsp;</div>
        </div>
      </template>

      <template slot="noOptions">
        Start typing to find contacts.
      </template>

      <template slot="noResult">
        &nbsp;
      </template>

    </multiselect>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["deliverable"],
  data() {
    return {
      addContactFlag: false,
      newContactName: "",
      deliverableId: "",
      contacts:[],
      isLoading:false,

    };
  },
  computed: {
    ...mapGetters(["allContacts","deliverableContactsLabel", 'initialContacts', 'userAbilities']),
  },
  methods: {
    ...mapActions(["createContact", "addDeliverableContact"]),

    onContactSearch(input) {
      if(!input && this.initialContacts.length > 0) {
        this.contacts = this.initialContacts;
        return;
      }
      if(typeof window.LIT !== 'undefined') {
        clearTimeout(window.LIT);
      }
      window.LIT = setTimeout(() => {
        input = input == false ? '' : input
        this.isLoading = true;
        axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
            .then(resp => {
              this.contacts = [];
                for(var contact of resp.data) {
                contact.name = contact.first_name +  " " + contact.last_name;
                contact.commaName = contact.last_name + ", " + contact.first_name;
                this.contacts.push(contact);
              }
            this.$store.commit('setInitialData', {contacts: this.tags})

            this.isLoading = false;
          })
      }, 500);
    },
    contactCustomLabel ({ name, company_name }) {
      if (company_name != null) {
        return `${name} – ${company_name}`
      } else {
        return `${name}`
      }
    },


    showAddContact() {
      if(!this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly) return;
      this.addContactFlag = true
      this.$nextTick(() => {
        this.$refs.deliverableListContacts.$el.focus()
      })
    },
    createContact(newContactName, deliverableId) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$bvModal.show("createWhoModal");
      //this.$store.commit('toggleAddContactModal')
    },
    outside() {
      this.$set(this, "addContactFlag", false);
    },
    getTitle(contacts) {
      let title = '';
      contacts.forEach((contact, index) => {
        if(index >= 3) {
          title += contact.name+'<br>';
        }
        return title
      });
      return title;
    }
  }
};
</script>

<style>
</style>